import { PresignedUrlPayload } from '@zonofi/common';
import {
  getChannel,
  getUserId,
  useAppSelector,
  useGetSignUrlMutation,
} from '@zonofi/zono-money-store';

export const useGetPresignedUrl = () => {
  const [getPresignedUrlApi] = useGetSignUrlMutation();
  const channel = useAppSelector(getChannel);
  const userId = useAppSelector(getUserId);

  const getPresignedUrl = async ({
    cntType,
    name,
    messageId,
    method,
    channelId = channel?.id,
    type,
  }: PresignedUrlPayload) => {
    const presignedUrlResponse = await getPresignedUrlApi({
      fileName: `/${name}`,
      type: type ?? cntType,
      contentType: cntType,
      destination: 'channels',
      method,
      userId,
      channelId,
      messageId,
    }).unwrap();
    const presignedUrl = presignedUrlResponse.presignedUrl;
    return presignedUrl;
  };

  return { getPresignedUrl };
};
